export const PATHS = {
	// COMMON
	common: {
		home: '/',
		reset: '/reset',
		signin: '/signin',
		errors: '/errors',
		change_password: '/change_password',
		api: '/api',
		graphql: '/graphql',
		signup: '/signup',
		tracking: '/tracking',
	},
	// Recruiter Portal
	recruiter: {
		home: '/home',
		single_sign_on: '/single_sign_on',
		salesforce_callback: '/salesforce/callback',
		candidates: '/candidates',
		view_as_traveler: '/view_as_traveler',
		travelers: '/travelers',
		find_job: '/find_job',
		profile: '/profile',
		my_jobs: '/my_jobs',
		activation: '/activation',
		timecards: '/timecards',
		popular_cities: '/popular_cities',
		suggested_jobs: '/suggested_jobs',
		recruiter_jobs: '/recruiter_jobs',
		jobs: '/jobs',
		toas: '/toas',
		job_info: '/job_info',
		job_applicants: '/job_applicants',
	},
}
